import {makeAutoObservable} from "mobx";
import {SpriteConfigName} from "@/entities/game/types";
import {RootStore} from "@/app/providers/StoreProvider";
import {IActiveEffect} from "@/entities/effects/types";

export class EffectsStore {

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    activeEffects = new Map<string, IActiveEffect>();

    enableEffect(effect: IActiveEffect) {
        this.activeEffects.set(effect.id, effect);
    }

    disableEffect(id: string) {
        this.activeEffects.delete(id);
    }

    getVisibleMultiplier(sprite: SpriteConfigName) {
        let value = this.rootStore.gameStore.getItemOptions(sprite)?.visible??true
        this.activeEffects.forEach(effect => {
            if (effect.type === 'visible' && effect.target === sprite) {
                value = false;
            }
        });
        return value;
    }

    getSpeedMultiplier(sprite: SpriteConfigName) {
        let value = 1;

        this.activeEffects.forEach(effect => {
            if (effect.type === 'speed' && effect.target === sprite) {
                value *= effect.value??1;
            }
        });

        return value;
    }

    getScoreMultiplier() {
        let value = 1;

        this.activeEffects.forEach(effect => {
            if (effect.type === 'score') {
                value *= effect.value??1;
            }
        });

        return value;
    }
}
